import { render } from "./ContentCheckComponent.vue?vue&type=template&id=d4054232&scoped=true"
import script from "./ContentCheckComponent.vue?vue&type=script&lang=js"
export * from "./ContentCheckComponent.vue?vue&type=script&lang=js"

import "./ContentCheckComponent.vue?vue&type=style&index=0&id=d4054232&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4054232"]])

export default __exports__